module.exports = __webpack_public_path__ + "static/media/chrome.dafc4a56.png";